import { useSelector } from 'react-redux';
import services from '../../services/servicesTeso';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useMensajesStore } from '../Generales_Mensajes_Validaciones/useMensajesStore';
import { useAuthStore } from '../useAuthStore';


export const useInventoryProductStore = () => {
    const navigate = useNavigate();
    const { user } = useSelector(state => state.auth);
    const { SuccessMensaje, SuccessDeleteMensaje, abrirCargar } = useMensajesStore();
    const { checkAuthToken } = useAuthStore();


    let userId = sessionStorage.getItem('uid');



    //Lista la información que se muestra en banco.js
    const list = async () => {
        //debugger
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            //debugger
            //abrirCargar();
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            //console.log("url:" + services.API.Product.List);
            const { data } = await axios.post(services.API.InventoryProduct.List, 
             { userId }, {headers: headerAxios});            
            if (data.respuesta === "success") {
                return data.Data;
                //dispatch(setBancos({ bancos: data.data }));
                //cerrarCargar();
            } else {
                if (data.respuesta_tipo === "warning") {
                    NoPermisoMensaje();
                }
                if (data === "") {
                    NoPermisoMensaje();
                }
            }
        } catch (error) {
            ErrorMensaje();
            console.log("error:" + error);
            throw error; // Puedes propagar el error para manejarlo en el componente
        }
    }

    //Lista la información que se muestra en banco.js
    const listDataForm = async () => {
        //debugger
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            //debugger
            //abrirCargar();
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            //console.log("url:" + services.API.Product.List);
            const { data } = await axios.post(services.API.Inventory.listDataForm, 
             { userId }, {headers: headerAxios});            
            if (data.respuesta === "success") {
                return data.Data;
                //dispatch(setBancos({ bancos: data.data }));
                //cerrarCargar();
            } else {
                if (data.respuesta_tipo === "warning") {
                    NoPermisoMensaje();
                }
                if (data === "") {
                    NoPermisoMensaje();
                }
            }
        } catch (error) {
            ErrorMensaje();
            console.log("error:" + error);
            throw error; // Puedes propagar el error para manejarlo en el componente
        }
    }


    //Actualiza e inserta. 
    const Upsert = async ({ inventoryID, 
        supplierId, 
        warehouseId,
        transactionDate,
        invoice,
        comments,
        productIds  }) => {
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            let data = [];
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
                        }
            
                  data  = await axios.post(services.API.Inventory.Upsert, { 
                    userId, 
                    inventoryID, 
                    supplierId, 
                    warehouseId,
                    transactionDate,
                    invoice,
                    comments,
                    productIds }, { headers: headerAxios });
            if (data.data.respuesta === "success") {
                console.log("data: " + data);
                SuccessMensaje();
                //dispatch(upSertBanco({ bancos: data.data }));
                navigate('/pages/inventory');
            }
            if (data.data.respuesta === "warning") {
                Swal.fire(
                    data.data.respuesta,
                    data.data.respuesta_Detalle,
                )
            }
        } catch (error) {
            console.log("error:" + error);
            ErrorMensaje();
        }
    }

    //Get Data to update.
    const getDataUpdate = async (id) => {
        //debugger
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            abrirCargar();
            const { data } = await axios.post(services.API.Inventory.GetData, { id }, { headers: headerAxios });
            if (data.respuesta === "success") {
                //history.pushState('')
                //history.push(`/pages/productEdit/${id}`, { productData });
                //navigate('/pages/bancoEditar');
                return data
                // navigate('/pages/bancoEditar');
                // dispatch(setBancoDataForm({ getData: data.data.banco }));
                // dispatch(setPaises({ paises: data.data.paises }));

            }
        } catch (error) {
            console.log("error:" + error);
        }
    }

    //Elimina 
    const Delete = async (id) => {
        //debugger
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            const { data } = await axios.post(services.API.Inventory.Delete, { id }, { headers: headerAxios });
            if (data.respuesta === "success") {
                console.log("data: " + data);
                SuccessDeleteMensaje();
            }
            if (data.respuesta_tipo === "warning") {
                Swal.fire(
                    'Problema con el Banco',
                    data.respuesta_detalle,
                )
            }
        } catch (error) {
            console.log("error:" + error);
            ErrorMensaje();
        }
    }


    const NoPermisoMensaje = async () => {
        Swal.fire(
            'No posee permisos para realizar esta acción.',
            'Contacte un administrador.',
            'question'
        )
    }

    const ErrorMensaje = async () => {
        Swal.fire(
            'Ha ocurrido un error.',
            'Contacte un administrador.',
            'error'
        )
    }

    return {
        //* Métodos
        list,
        listDataForm,
        Upsert,
        getDataUpdate,
        Delete
    }

}